import { TextField, TextFieldProps } from 'components/form'

const parseCoordinate = (rawValue: string) => {
  let value = rawValue.trim().replace('.', ',')
  const negative = value.startsWith('-')

  value = value.replace(/[^\d,]/g, '')

  const [integer = '', ...decimalParts] = value.split(',')
  const hasDecimalSeparator = value.includes(',')
  const decimals = decimalParts.join('').slice(0, 8)

  if (!/\d/.test(value) && !negative) return undefined

  let parsed = (negative ? '-' : '') + integer
  if (hasDecimalSeparator) parsed = parsed + ',' + decimals

  return parsed || undefined
}

export function CoordinateField(props: TextFieldProps) {
  return <TextField {...props} parse={parseCoordinate} />
}

export const convertCoordinate = (value?: string): number | null => {
  if (!value || value === '-' || value === '-,') return null

  const coordinate = Number(value.replace(',', '.'))
  return Number.isFinite(coordinate) ? coordinate : null
}

export const isCoordinateValid = (value?: string): string | undefined =>
  value && !Number.isFinite(Number(value.replace(',', '.'))) ? 'Campo inválido.' : undefined
